var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DevicePoC22',{ref:"devicePoC22"}),_c('DevicePoC23',{ref:"devicePoC23"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }